import React from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import Icon from '../Icon/Icon'
import Button from '../Button/Button'
import Cross from '../../icons/cross.svg'
import Approved from '../../icons/approved.svg'
import PropTypes from 'prop-types'

import styles from './ModalAdditionResult.module.scss'

const ModalAdditionResult = ({ isOpen, toggleModal, content }) => {
	return (
		<Modal isOpen={isOpen} toggle={toggleModal} className={styles.modal}>
			<ModalHeader className={styles.header}>
				<Button
					className={styles.closeButton}
					onClick={() => {
						toggleModal()
					}}
				>
					<Icon name={Cross} className={styles.closeButton} />
				</Button>
			</ModalHeader>
			<ModalBody>
				<Icon name={Approved} className={styles.approveIcon} />
				<h2 className={styles.youIn}>{content}</h2>
			</ModalBody>
			<ModalFooter className={styles.footer}>
				<Button 
					className={styles.closeButtonBottom}
					color='secondary'
					onClick={() => {
						toggleModal()
					}}
				>
					Close
				</Button>
			</ModalFooter>
		</Modal>
	)
}

ModalAdditionResult.propTypes = {
	isOpen: PropTypes.bool,
	toggleModal: PropTypes.func,
	content: PropTypes.node
}
ModalAdditionResult.dafaultProps = {
	isOpen: false,
	toggleModal: () => {}
}

export default ModalAdditionResult
